import { css } from '@flex-design-system/stitches-react';

const textBase = css({
  color: "$grayDark"
})();
const paragraph = css({
  lineHeight: 1.5
})();

export { paragraph, textBase };
//# sourceMappingURL=viewModeOnly.mjs.map
